// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Rzr6","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3hNMl","obliqueLine":"membershipbadge_obliqueLine__3ssQK"};